import React, { useState } from 'react';
import './Sidebar.css'; // Fichier CSS dédié (pour l'effet accordéon, couleurs, etc.)

function Sidebar() {
  // State qui contient l'identifiant du menu actuellement ouvert (ou null)
  const [openMenu, setOpenMenu] = useState(null);

  // Ouvre / ferme un menu
  const toggleMenu = (menuId) => {
    setOpenMenu((current) => (current === menuId ? null : menuId));
  };

  return (
    <div className="sidebar">
      {/* Branding / Titre */}
      <div className="sidebar-brand">
        <i className="fas fa-laugh-wink brand-icon"></i>
        <span className="brand-text">Club Manager</span>
      </div>

      <hr />

      {/* Dashboard */}
      <div className="nav-item">
        <a className="nav-link" href="#/dashboard">
          <i className="fas fa-fw fa-tachometer-alt"></i>
          <span>Dashboard</span>
        </a>
      </div>

      <hr />

      {/* === GESTION DU CLUB === */}
      <div className="sidebar-heading">Gestion du Club</div>

      {/* Membres */}
      <div className="nav-item">
        <button
          className="nav-link collapsed"
          onClick={() => toggleMenu('members')}
        >
          <i className="fas fa-fw fa-users"></i>
          <span>Membres</span>
        </button>
        <div className={`submenu ${openMenu === 'members' ? 'open' : ''}`}>
          <a className="collapse-item" href="#/members/list">Liste des Membres</a>
          <a className="collapse-item" href="#/members/add">Ajouter un Membre</a>
          <a className="collapse-item" href="#/members/import">Importer</a>
          <a className="collapse-item" href="#/members/categories">Catégories / Groupes</a>
        </div>
      </div>

      {/* Équipes / Activités */}
      <div className="nav-item">
        <button
          className="nav-link collapsed"
          onClick={() => toggleMenu('teams')}
        >
          <i className="fas fa-fw fa-futbol"></i>
          <span>Équipes & Activités</span>
        </button>
        <div className={`submenu ${openMenu === 'teams' ? 'open' : ''}`}>
          <a className="collapse-item" href="#/teams/list">Liste des Équipes</a>
          <a className="collapse-item" href="#/activities">Activités / Sports</a>
          <a className="collapse-item" href="#/matches">Matchs / Événements Sportifs</a>
          <a className="collapse-item" href="#/trainings">Planning Entraînements</a>
        </div>
      </div>

      {/* Calendrier / Événements */}
      <div className="nav-item">
        <button
          className="nav-link collapsed"
          onClick={() => toggleMenu('calendar')}
        >
          <i className="fas fa-fw fa-calendar-alt"></i>
          <span>Calendrier / Événements</span>
        </button>
        <div className={`submenu ${openMenu === 'calendar' ? 'open' : ''}`}>
          <a className="collapse-item" href="#/calendar">Calendrier Général</a>
          <a className="collapse-item" href="#/events">Liste des Événements</a>
          <a className="collapse-item" href="#/events/create">Créer un Événement</a>
        </div>
      </div>

      {/* Finances */}
      <div className="nav-item">
        <button
          className="nav-link collapsed"
          onClick={() => toggleMenu('finance')}
        >
          <i className="fas fa-fw fa-money-bill-wave"></i>
          <span>Finances</span>
        </button>
        <div className={`submenu ${openMenu === 'finance' ? 'open' : ''}`}>
          <a className="collapse-item" href="#/finance/fees">Cotisations / Adhésions</a>
          <a className="collapse-item" href="#/finance/payments">Paiements & Factures</a>
          <a className="collapse-item" href="#/finance/expenses">Dépenses</a>
          <a className="collapse-item" href="#/finance/budgets">Budgets & Rapports</a>
        </div>
      </div>

      {/* Communication */}
      <div className="nav-item">
        <button
          className="nav-link collapsed"
          onClick={() => toggleMenu('communication')}
        >
          <i className="fas fa-fw fa-bullhorn"></i>
          <span>Communication</span>
        </button>
        <div className={`submenu ${openMenu === 'communication' ? 'open' : ''}`}>
          <a className="collapse-item" href="#/announcements">Annonces</a>
          <a className="collapse-item" href="#/news">Actualités</a>
          <a className="collapse-item" href="#/messages">Messages Privés</a>
          <a className="collapse-item" href="#/mailing">Mailing / Newsletters</a>
        </div>
      </div>

      {/* Infrastructures */}
      <div className="nav-item">
        <button
          className="nav-link collapsed"
          onClick={() => toggleMenu('facilities')}
        >
          <i className="fas fa-fw fa-building"></i>
          <span>Infrastructures</span>
        </button>
        <div className={`submenu ${openMenu === 'facilities' ? 'open' : ''}`}>
          <a className="collapse-item" href="#/facilities/list">Liste des Installations</a>
          <a className="collapse-item" href="#/facilities/reservations">Réservations</a>
          <a className="collapse-item" href="#/facilities/maintenance">Maintenance</a>
        </div>
      </div>

      <hr />

      {/* === ADMINISTRATION === */}
      <div className="sidebar-heading">Administration</div>

      {/* Statistiques / Rapports */}
      <div className="nav-item">
        <button
          className="nav-link collapsed"
          onClick={() => toggleMenu('reports')}
        >
          <i className="fas fa-fw fa-chart-bar"></i>
          <span>Statistiques / Rapports</span>
        </button>
        <div className={`submenu ${openMenu === 'reports' ? 'open' : ''}`}>
          <a className="collapse-item" href="#/reports/activities">Activités & Participation</a>
          <a className="collapse-item" href="#/reports/financial">Rapports Financiers</a>
          <a className="collapse-item" href="#/reports/custom">Rapports Personnalisés</a>
        </div>
      </div>

      {/* Paramètres */}
      <div className="nav-item">
        <button
          className="nav-link collapsed"
          onClick={() => toggleMenu('settings')}
        >
          <i className="fas fa-fw fa-cog"></i>
          <span>Paramètres</span>
        </button>
        <div className={`submenu ${openMenu === 'settings' ? 'open' : ''}`}>
          <a className="collapse-item" href="#/settings/account">Mon Compte</a>
          <a className="collapse-item" href="#/settings/roles">Rôles & Permissions</a>
          <a className="collapse-item" href="#/settings/clubinfo">Informations du Club</a>
          <a className="collapse-item" href="#/settings/backup">Sauvegarde / Export</a>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
